function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
import { popSubscribeFn, pushSubscribeFn } from "./utils/collection";
import { getHost } from "./utils/share";
var anyOrigin = '*';
var fromWindow = function fromWindow(contentWindow, config) {
  if ((typeof window === "undefined" ? "undefined" : _typeof(window)) === undefined) {
    console.error("[appbridge] Please make sure that SDK is used in embedded application.! ");
    return;
  }
  var host = config.host,
    debug = config.debug;
  if (!host) host = getHost();
  var messageOrigin;
  var protocol = 'https';
  try {
    if (debug) {
      protocol = 'http';
      messageOrigin = host === anyOrigin ? anyOrigin : new URL("".concat(protocol, "://").concat(host)).origin;
      console.log("[appbridge] connect host: ".concat("".concat(protocol, "://").concat(host)));
    } else {
      messageOrigin = new URL("".concat(protocol, "://").concat(host)).origin;
    }
  } catch (error) {
    console.error("[appbridge] Client initialization failed. [Host] is missing. Please check whether you pass in the correct parameters.!");
  }
  return {
    config: config,
    localOrigin: host,
    hostFrame: contentWindow,
    dispatch: function dispatch(action, message) {
      var payLoad = message.payLoad;
      var postMsg = {
        action: action,
        payLoad: payLoad
      };
      contentWindow === null || contentWindow === void 0 ? void 0 : contentWindow.postMessage(postMsg, messageOrigin);
      return postMsg;
    },
    subscribe: function subscribe(action, fn) {
      pushSubscribeFn(action, fn);
    },
    unsubscribe: function unsubscribe(action) {
      popSubscribeFn(action, 'remove');
    }
  };
};

// Monitor communication messages
var initPostMessage = function initPostMessage(config) {
  console.log("[appbridge] Initialize communication......");
  if (window.addEventListener) {
    window.addEventListener('message', function (e) {
      var _e$data = e.data,
        action = _e$data.action,
        done = _e$data.done;
      if (done) {
        popSubscribeFn(action, 'excute', e, config);
      }
    });
  } else {
    window.onmessage = function (e) {
      var _e$data2 = e.data,
        action = _e$data2.action,
        done = _e$data2.done;
      if (done) {
        popSubscribeFn(action, 'excute', e, config);
      }
    };
  }
  console.log("[appbridge] Initialization communication complete...");
};
export default {
  fromWindow: fromWindow,
  initPostMessage: initPostMessage
};